import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=412aa56b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=412aa56b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412aa56b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('412aa56b')) {
      api.createRecord('412aa56b', component.options)
    } else {
      api.reload('412aa56b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=412aa56b&scoped=true&", function () {
      api.rerender('412aa56b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/comp/SearchFilterTokens.vue"
export default component.exports